import PropTypes from 'prop-types';
import React from 'react';
import Box from '@mui/material/Box';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import GhostingButton from '../GhostingButton';
import UsersButton from '../UsersButton';
import { ConfirmDialog } from '../ConfirmDialog';

function RecordTableTools(props) {
	const ConfirmDelete = (
		<ConfirmDialog
			title="Danger"
			text="Are you sure you want to delete this item?"
			onConfirm={props.deleteAction}
			{...props.confirmProps}
		>
			<DeleteButton disabled={props.deleteDisabled} />
		</ConfirmDialog>
	);
	const DeleteBtn = props.noConfirmDelete ? <DeleteButton onClick={props.deleteAction} disabled={props.deleteDisabled} /> : ConfirmDelete;

	return (
		<Box whiteSpace="nowrap">
			{props.ghostAction ? <GhostingButton onClick={props.ghostAction} /> : null}
			{props.userListHref ? <UsersButton href={props.userListHref} /> : null}
			{props.editHref ? <EditButton href={props.editHref} disabled={props.editDisabled} /> : null}
			{props.editAction ? <EditButton onClick={props.editAction} disabled={props.editDisabled} /> : null}
			{props.deleteAction && DeleteBtn}
		</Box>
	);
}

RecordTableTools.propTypes = {
	editHref: PropTypes.string,
	editAction: PropTypes.func,
	editDisabled: PropTypes.bool,
	userListHref: PropTypes.string,
	deleteAction: PropTypes.func,
	deleteDisabled: PropTypes.bool,
	ghostAction: PropTypes.func,
	noConfirmDelete: PropTypes.bool,
	// eslint-disable-next-line react/forbid-prop-types
	confirmProps: PropTypes.object,
};

RecordTableTools.defaultProps = {
	editHref: undefined,
	editAction: undefined,
	editDisabled: false,
	userListHref: undefined,
	deleteAction: undefined,
	deleteDisabled: false,
	ghostAction: undefined,
	noConfirmDelete: false,
	confirmProps: undefined,
};

export default RecordTableTools;
